import type { ReactChild, ReactFragment, ReactNode, ReactPortal } from 'react';
import { Suspense } from 'react';
import settings from '../private/settings';

export interface ISuspenseProps {
    fallback: boolean | ReactChild | ReactFragment | ReactPortal | null;
    children: ReactNode;
}

function SuspenseWrapper(props: ISuspenseProps): JSX.Element {
    return settings.isSuspenseSupported ? (
        <Suspense fallback={props.fallback}>{props.children}</Suspense>
    ) : (
        <>{props.children}</>
    );
}

export default SuspenseWrapper;
